import React from 'react';
import classNames from 'classnames';
import { allowedCountries } from '../../SeoLandingPages/Pages/helpers';
import css from './CountriesTab.css';

export default ({ setCountry, country, countries = allowedCountries }) => {
    return (
        <nav className={css.tabsNavigation}>
            {countries.map(countryName => (
                <div
                    key={countryName}
                    onClick={() => setCountry(countryName)}
                    className={classNames(css.tab, {
                        [css.tabSelected]: countryName === country,
                    })}
                >
                    <span className={css.content}>{countryName}</span>
                </div>
            ))}
        </nav>
    );
};
